import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MeasuredVirtualList',
  props: {
    totalHeight: {},
    offsetTop: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "virtual-spacer",
    style: _normalizeStyle({ height: `${_ctx.totalHeight}px` })
  }, [
    _createElementVNode("div", {
      class: "virtual-content",
      style: _normalizeStyle({ top: `${_ctx.offsetTop}px` })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4)
  ], 4))
}
}

})